import { useCallback } from "react"
import { useMutationWithErrorToast } from "@/hooks/useMutationWithErrorToast"
import {
  Ch_updateProgressNoteTreatmentPlanInput,
  chUpdateProgressNoteTreatmentPlanMutation,
  chUpdateProgressNoteTreatmentPlanMutation$data,
} from "@/modules/patients/services/ch/__generated__/chUpdateProgressNoteTreatmentPlanMutation.graphql"
import { chUpdateProgressNoteTreatmentPlanMutation as chMutation } from "@/modules/patients/services/ch/chUpdateProgressNoteTreatmentPlanMutation"
import {
  De_updateProgressNoteTreatmentPlanInput,
  deUpdateProgressNoteTreatmentPlanMutation,
  deUpdateProgressNoteTreatmentPlanMutation$data,
} from "@/modules/patients/services/de/__generated__/deUpdateProgressNoteTreatmentPlanMutation.graphql"
import { deUpdateProgressNoteTreatmentPlanMutation as deMutation } from "@/modules/patients/services/de/deUpdateProgressNoteTreatmentPlanMutation"
import { Country } from "@/types/__generated__/union-types"

export function useUpdateProgressNoteTreatmentPlanMutation(
  country: Country,
): [
  (
    input: Ch_updateProgressNoteTreatmentPlanInput & De_updateProgressNoteTreatmentPlanInput,
    handleComplete?: (
      response: deUpdateProgressNoteTreatmentPlanMutation$data & chUpdateProgressNoteTreatmentPlanMutation$data,
    ) => void,
    handleError?: (error: Error) => void,
  ) => void,
  boolean,
] {
  const mutation = (() => {
    switch (country) {
      case "CH":
        return chMutation
      case "DE":
        return deMutation
    }
  })()

  const [commit, isInFlight] = useMutationWithErrorToast<
    deUpdateProgressNoteTreatmentPlanMutation & chUpdateProgressNoteTreatmentPlanMutation
  >(mutation)

  return [
    useCallback(
      (
        input: Ch_updateProgressNoteTreatmentPlanInput & De_updateProgressNoteTreatmentPlanInput,
        handleComplete?: (
          response: deUpdateProgressNoteTreatmentPlanMutation$data & chUpdateProgressNoteTreatmentPlanMutation$data,
        ) => void,
        handleError?: (error: Error) => void,
      ) => {
        commit({
          variables: { input },
          onCompleted: (
            response: deUpdateProgressNoteTreatmentPlanMutation$data & chUpdateProgressNoteTreatmentPlanMutation$data,
          ) => {
            const { errors } = response.updateProgressNoteTreatmentPlan
            if (errors === null || errors.length === 0) {
              handleComplete?.(response)
            }
          },
          onError(error) {
            handleError?.(error)
          },
        })
      },
      [commit],
    ),
    isInFlight,
  ]
}
